module.exports = __webpack_public_path__ + "img/banner1EN.b6af07cc.png";